import { render, staticRenderFns } from "./comp-guidance.vue?vue&type=template&id=217271ba&scoped=true"
import script from "./comp-guidance.vue?vue&type=script&lang=js"
export * from "./comp-guidance.vue?vue&type=script&lang=js"
import style0 from "./comp-guidance.vue?vue&type=style&index=0&id=217271ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_3rkfgw2sufrnjnd565hqczepoe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217271ba",
  null
  
)

export default component.exports